import { initFlipClock, getFlipClockInstance } from '../flip-clock/init-flip-clock.js';
import FlipSettingsManager from '../settings/flip-settings-manager.js';

class FlipPageModule {
  constructor() {
    this.settingsManager = null;
    this.resizeHandler = null;
  }

  ensureClock(app) {
    const clock = getFlipClockInstance() || initFlipClock();
    if (clock && typeof app?.setFlipClockInstance === 'function') {
      app.setFlipClockInstance(clock);
    }
    return clock;
  }

  ensureSettingsManager() {
    if (!this.settingsManager) {
      this.settingsManager = new FlipSettingsManager();
      window.settingsManager = this.settingsManager;
      const handler = () => {
        if (this.settingsManager && typeof this.settingsManager.handleResize === 'function') {
          this.settingsManager.handleResize();
        }
      };
      const debounced = window.Utils && typeof window.Utils.debounce === 'function'
        ? window.Utils.debounce(handler, 100)
        : handler;
      window.addEventListener('resize', debounced);
      this.resizeHandler = debounced;
    }
    return this.settingsManager;
  }

  openSettings() {
    const manager = this.ensureSettingsManager();
    if (manager && typeof manager.open === 'function') {
      manager.open();
    }
  }
}

function registerModule() {
  const app = window.digitalClockApp;
  if (!app || typeof app.registerPageModule !== 'function') {
    return;
  }
  const module = new FlipPageModule();
  app.registerPageModule('flip', module);
  module.ensureClock(app);
}

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', registerModule);
} else {
  registerModule();
}
